module.exports = __webpack_public_path__ + "img/usdc.3b5972c1.svg";